import React from "react";
import { useRef} from "react";
import ProjectCard from "./ProjectCard";
import ProjectTimeline from "./ProjectTimeline";
import { Typography } from "@mui/material";
import {globalTheme} from "../components/Theme"
import {makeStyles} from '@mui/styles';
import { Route} from "react-router-dom";
import { InView } from "react-intersection-observer";
import { useState } from "react";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    header:{
        fontWeight: 600,
        padding: theme.spacing(4)
    },
    timelineDiv: {
      width: "100%"
    }
}));

export default function ProjectRoute(props) {
  const classes = useStyles(globalTheme);
  const divRef = useRef(null);
  const location = useLocation();
  const scrollRef = useRef(false);
  const [projectCount, setProjectCount] = useState(0);
  const maxProjectsLength = 100;
  const projectLoadIncrement = 1;

  // useEffect(() => {
  //   const path = location.pathname;
  //   const splitPathArray = path.split("/");
  //   const lastElem = splitPathArray[splitPathArray.length - 1];
  //   console.log(lastElem);

  //   if(lastElem === "test") {
  //     props.scrollToProject(props.projectsList[1][0].key);
  //     console.log(props.projectsList[1][0].key);
  //   }

  //   console.log('Location changed: ' + location.pathname);
  // }, [location, props]);

  const inViewOnChange = (inView, entry) => {
    //console.log(inView)
    //console.log(entry)
    //console.log(location.pathname);
    
    if(projectCount < maxProjectsLength && inView) {
      setProjectCount(projectCount+projectLoadIncrement);
      //console.log(projectCount);
    }
  }

  const changeRoute = (i) => {
    props.changeRoute(props.projectsInfo, i);
  }

  const scrollToDiv = () => {
    if(scrollRef.current){
      return;
    }
    
    divRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });

    scrollRef.current = true;
  }

  return (
    <React.Fragment>
      <Typography variant="h3" align="center" className={classes.header} style={globalTheme.palette.heading}>TABLE OF CONTENTS</Typography>
      <ProjectTimeline projectsInfo={props.projectsInfo} changeRoute={changeRoute}/>
      <div key={props.projectsInfo.title + "scrollDiv"} ref={divRef} className={classes.timelineDiv}/>
      {
        props.projectsInfo.list.map(
            (project, index) => (
              <Route exact path={[props.projectsInfo.route + "/" + project[0].key, props.projectsInfo.route]} 
              key={props.projectsInfo.route + project[0].key + "_route"} >
              {
                (index < projectCount+1 || location.pathname !== props.projectsInfo.route) && 
                <InView onChange={inViewOnChange} triggerOnce key={props.projectsInfo.route + project[0].key + "_inView"}>
                  {({ inView, ref, entry }) => (
                    <div key={props.projectsInfo.title + "inViewDiv"} ref={ref}>
                    <ProjectCard 
                      descData={project[0]} mediaData={project[1].media} scrollToDiv={scrollToDiv}
                      />
                    </div>
                  )}
                </InView>
              }
              </Route>
            )
        )
      }
    </React.Fragment>
  );
}